<template>
  <div ref="AppealForm" class="appeal-form">
    <div class="type_radio_wrapper">
      <label class="label">
        <span class="require">*</span>
        主体类型
      </label>
      <span>
        <el-radio :disabled="isEdit" v-model="roleType" :label="ROLE_TYPE_ENUM.ORGANIZATION.code">组织机构</el-radio>
        <el-radio :disabled="isEdit" v-model="roleType" :label="ROLE_TYPE_ENUM.PRIVATE.code">个人</el-radio>
      </span>
    </div>
    <OrganizationForm v-bind="$props" v-if="roleType ===ROLE_TYPE_ENUM.ORGANIZATION.code" ref="organizationRef"></OrganizationForm>
    <PersonForm v-bind="$props" v-else ref="personRef"></PersonForm>
  </div>
</template>

<script>
import { ROLE_TYPE_ENUM } from '@/views/person/const'

import OrganizationForm from './Organization.vue'
import PersonForm from './Person.vue'
export default {
  name: 'AppealEditForm',
  components: {
    OrganizationForm,
    PersonForm
  },
  props: {
    isEdit: Boolean,
    defaultData: Object,
    loading: Boolean,
  },
  data() {
    return {
      roleType: this.defaultData?.roleType ?? ROLE_TYPE_ENUM.ORGANIZATION.code,
      ROLE_TYPE_ENUM
    }
  },
  methods: {
    async genData() {
      return this.roleType === ROLE_TYPE_ENUM.ORGANIZATION.code ? await this.$refs.organizationRef.genData() : await this.$refs.personRef.genData()
    }
  },

}
</script>

<style scoped lang="scss">
.appeal-form {
  .type_radio_wrapper{
    margin-top: 22px;
  }
  .label {
    display: inline-block;
    padding-right: 12px;
    line-height: 36px;
    width: 150px;

    text-align: right;
    font-size: 14px;
    color: #606266;

    .require {
      color: red;
    }
  }
}

</style>
